import { render, staticRenderFns } from "./AddWebhookModal.vue?vue&type=template&id=532cf869&scoped=true&"
import script from "./AddWebhookModal.vue?vue&type=script&lang=js&"
export * from "./AddWebhookModal.vue?vue&type=script&lang=js&"
import style0 from "./AddWebhookModal.vue?vue&type=style&index=0&id=532cf869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532cf869",
  null
  
)

export default component.exports